module.exports = __webpack_public_path__ + "static/media/wikipediaIcon.34941d0d.svg";